module.exports = __webpack_public_path__ + "img/honor_10.517889de.png";